import { type IAgentOfferListingsQuery } from 'application/querySchemas/IAgentOfferListingsQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import {
    type IAgentOfferListingsClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentOfferListingsClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentOfferListingsQuery implements IAgentOfferListingsQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentOfferListingsClient')
        public readonly agentOfferListingsClient: IAgentOfferListingsClient,
    ) {}

    public async fetchOffers(params: any): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentOfferListingsClient.get({
            token: this.agentUserToken.get() || '',
            ...params,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
